import React from "react";
import AsideBlock from "../../../components/AsideBlock";
import AsidePhotoList from "../../../camCaptureRecord/components/AsidePhotoList";
import AsideDownload from "../../../download/components/AsideDownload";
import AsideMultiple from "../../../multipleScreen/components/AsideMultiple";
import AsideShift from "../../../shiftBrowser/components/AsideShift";
import { Button } from "antd";
import styles from "../../../camCaptureRecord/index.module.scss";
import useModalHandler from "../../../../../../utils/v2/useModalHandler";
import AllModal from "../AllModal";

export default function AsideAll() {
    const allModal = useModalHandler(undefined, { remove: true });

    return (
        <>
            <AsideBlock
                title="全过程记录"
                extra={
                    <Button
                        type="link"
                        className={styles.button}
                        onClick={allModal.open}>
                        查看更多&gt;
                    </Button>
                }>
                {""}
            </AsideBlock>
            <AsidePhotoList />
            <AsideDownload />
            <AsideMultiple />
            <AsideShift />

            {allModal.render(<AllModal />)}
        </>
    );
}
